import type { PropsWithChildren } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface NavContainerProps {
  className?: string;
}

export const NavContainer = ({
  children,
  className,
}: PropsWithChildren<NavContainerProps>) => (
  <nav
    className={classNames(
      "bg-primary flex size-full flex-col items-start justify-between gap-3 !p-0 px-5 pb-2 pt-6 md:gap-4 md:px-6 md:py-4 lg:grid lg:grid-cols-3 lg:!items-center",
      className,
    )}
  >
    {children}
  </nav>
);
